import cx from "classnames";
import ArrowIcon from "src/components/general/ArrowIcon/ArrowIcon";
import { AsideCollapseExpandIcon } from "src/components/general/Icons/Icons";
import { useGlobalLocalContext } from "src/storage/localStorage";
import { useShallow } from "zustand/shallow";

interface SidebarExpandCollapseButtonProps {
  className?: string;
}

const SidebarExpandCollapseButton = ({
  className,
}: SidebarExpandCollapseButtonProps) => {
  const [isCollapsed, toggleSideBarCollapsed] = useGlobalLocalContext(
    useShallow((s) => [s.sideBarCollapsed, s.toggleSideBarCollapsed])
  );

  return (
    <div
      onClick={toggleSideBarCollapsed}
      className={cx("flex gap-2 cursor-pointer", className)}
    >
      <ArrowIcon
        Icon={AsideCollapseExpandIcon}
        size={20}
        left={!isCollapsed}
        right={isCollapsed}
      />
      {!isCollapsed && <span>Collapse</span>}
    </div>
  );
};

export default SidebarExpandCollapseButton;
